import React from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../atoms/button/LinkButton';
import Modal from '../atoms/modal/Modal';

const ModalMail = ({ open, onClose, email }) => {
  return (
    <Modal
      title={'メール送信完了'}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onClick={onClose}
      className="mailPage mailModal"
      overlayClassName="contentCenter"
      disableOverlayClick={true}
    >
      <div className="mailModalBody">
        <p className="mailModalBodyLeadText">下記のお客様のメールアドレスに認証メールをお送りいたしました</p>
        <div className="emaiInfo">
          <div className="emailTitle">メールアドレス</div>
          <div className="email">{email}</div>
        </div>
        <div className="noteTexts">
          <div className="checkIcon">
            <img src="/dpp/img/icons/checkRed.svg" alt="check icon" />
          </div>
          <div className="noteTextBody">
            <p className="noteTextTitle">メールが届かない場合</p>
            <p className="noteText">
              メールアドレスが正しく入力されていますか？ <br />
              「nta.co.jp」からのメールを受信できるように設定いただいていますか？<br /><br />
              これらをご確認の上再送する場合は閉じるボタンを押して、メールを再送してください
            </p>
          </div>
        </div>
        <div className="modalCloseButton">
          <LinkButton buttonType="navigateMid" onClick={onClose}>閉じる</LinkButton>
        </div>
      </div>
    </Modal>
  );
};

ModalMail.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
};

export default ModalMail;
